import * as constants from './constants';
import {post} from "../../../utils/request";
import {ORDER_CREATE} from '../../../utils/api';

export const CreateOrder = (Entity) => ({
    type: constants.CREATE_ORDER,
    value: Entity
});

export const createOrder = (params) => {
    return (dispatch) => {
        return post(ORDER_CREATE, params)
            .then((response) => {
                return dispatch(CreateOrder(response.data));
            });
    }
};

